import { ROUTE_PATH_DECKS } from "page/deck-manager/deck/decks/decks-config";

export const ROUTE_PATH_YOUR_DECKS = `${ROUTE_PATH_DECKS}/yours`;
